import React from "react";
import ReactDOM from "react-dom/client";
import "./Styles/tailwind.css";
import "./Styles/custom.css";
import "./Styles/style_report.css";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

window.global = {
  // server_url: "http://192.168.1.17:8000", siva
  // server_url: "http://10.10.10.39:8000",
  // server_url: "http://103.66.12.3:3002",
  // server_url: "http://localhost:8000",
  // server_url: "http://117.232.75.163:8050",
  server_url: "https://xpertxpress.transforma.in:8445",
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/integrity-checks">
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
